import { useDashboardPermissions } from '@components'

import type { FormValues } from '../Checkout.types'
import { useNotificationShopPreferencesMutation } from '../queries/useNotificationShopPreferencesMutation'
import { useNotificationShopPreferencesQuery } from '../queries/useNotificationShopPreferencesQuery'
import { getCartAbandonmentInitialValues } from '../utils/getCartAbandonmentInitialValues'
import { getCartAbandonmentPayload } from '../utils/getCartAbandonmentPayloadPayload'

export const useAbandonedCheckoutRemindersSettings = () => {
  const { hasPermission } = useDashboardPermissions()
  const { notificationShopPreferencesQuery, invalidateNotificationShopPreferencesQuery } =
    useNotificationShopPreferencesQuery(undefined, {
      enabled: hasPermission('settings.checkout.notifications'),
    })
  const { notificationShopPreferencesMutation } = useNotificationShopPreferencesMutation()

  const update = async (values: FormValues) => {
    await notificationShopPreferencesMutation.mutateAsync([getCartAbandonmentPayload(values)], {
      onSuccess: () => {
        invalidateNotificationShopPreferencesQuery()
      },
    })
  }

  return {
    abandonedCheckoutRemindersSettings: {
      initialValues: getCartAbandonmentInitialValues(notificationShopPreferencesQuery.data),
      abandonedCheckout: {
        options: [
          { checkedValue: 'recommended', label: 'Recommended (three reminders)' },
          { checkedValue: 'light', label: 'Light (one reminder)' },
          { checkedValue: 'off', label: 'Off' },
        ],
      },
      update,
    },
  }
}
